<template>
  <Marco>
    <div class="cl one-col position" slot="content">
      <div class="col2" />

      <div class="col1">
        <div class="main-title">
          <h1 class="title">
            &#128542; Ooops!!!! Parece que algo ha ido mal. Se ha producido un
            error.
          </h1>
        </div>

        <div class="field-row">
          <div class="field">
            <div class="wysiwyg type2">
              <p align="justify">
                {{ errorMessage }}
                <span v-if="errorMessage">.</span> Lo sentimos. Se ha producido
                un error.
              </p>
              <p align="justify">
                Por favor, llámanos al
                <a href="tel:915948800">915948800</a> o, si lo prefieres,
                déjanos tus datos en el enlace
                <a href="#" @click.prevent="popUpConfirmTel = true">
                  <span class="noSeparar">TE LLAMAMOS</span>
                </a>
                y nuestro Centro de Atención al Cliente se pondrá en contacto
                contigo a la mayor brevedad posible.
              </p>
              <p>Disculpa las molestias. Gracias.</p>
            </div>
            <TeLlamamos v-if="popUpConfirmTel" @close="confirmTel(false)" />
          </div>
        </div>
      </div>
    </div>
  </Marco>
</template>

<script>
export default {
  store: ["step"],

  props: {
    errorMessage: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      popUpConfirmTel: false
    };
  },

  methods: {
    confirmTel(val) {
      this.popUpConfirmTel = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.numPresupuesto {
  font-size: 2rem;
  font-weight: 400;
  color: white;
  padding-right: 1rem;
  text-align: right;
  span {
    background-color: #999;
    border-radius: 0.5rem;
    padding: 0.2rem 0.6rem 0.2rem 0.6rem;
  }
}

.noSeparar {
  white-space: nowrap;
}
</style>
